import { ref } from 'vue';

/** undefined = aún no cargó; null = error / sin datos; object = respuesta API */
export const siteContactPublicRef = ref(undefined);
